define(['moduler'], function (Moduler) { // eslint-disable-line no-unused-vars
    'use strict';

    // modular finance integration script

    return Moduler.create({
        defaults: {
            debugMode: false,
            baseUrl: 'https://widget.datablocks.se/api/rose',
            widgetSelector: '.modfin-widget'
        },

        clean: function (data) {
            return data
                .replace(/<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi, '')
                .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
                .trim();
        },

        init: function () {
            var self = this;

            let widgets = [];
            self.el.querySelectorAll(self.options.widgetSelector).forEach(w => {
                let widgetData = {
                    query: '#' + w.id,
                    widget: w.getAttribute('data-mf-widget'),
                    locale: w.getAttribute('data-mf-locale'),
                    token: w.getAttribute('data-mf-token'),
                    callback: function (data) {
                        w.classList.add('ready');
                        return self.clean(data);
                    }
                };
                if (widgetData.token?.length > 0 && widgetData.query.length > 1) {
                    widgets.push(widgetData);
                } else {
                    w.remove();
                }
            });

            if (widgets.length > 0) {
                if (!window._MF) {
                    var b = document.createElement("script");
                    b.type = "text/javascript";
                    b.async = true;
                    b.src = self.options.baseUrl + "/assets/js/loader-v5.js";
                    document.getElementsByTagName("body")[0].appendChild(b);
                }
                window._MF = window._MF || {
                    data: [],
                    url: self.options.baseUrl,
                    ready: !!0,
                    render: function () { window._MF.ready = !0 },
                    push: function (w) { window._MF.data.push(w) }
                };

                window._MF.push(widgets);
            }
        }
    });
});